import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useParams, useLocation, useHistory} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import IconButton from '@mui/material/IconButton';
import queryString from 'query-string';

import PrimaryAppBar from './PrimaryAppBar';
import SecondaryAppBar from './SecondayAppBar';
import ExerciseMenu from './ExerciseMenu';
import CreateEditReadingExercise from './CreateEditReadingExercise';
import CreateEditWritingExercise from './CreateEditWritingExercise';
import CreateEditWordWorkExercise from './CreateEditWordWorkExercise';
import CreateEditWordSortExercise from './CreateEditWordSortExercise';
import CreateEditWordDivisionExercise from './CreateEditWordDivisionExercise';
import CreateEditAssessmentExercise from './CreateEditAssessmentExercise';
import VisibilityChip from './VisibilityChip';

import {fetchExercise, selectExercises} from '../../redux/slices/builder';
import {selectUserGroup} from '../../redux/slices/user';
import {
  FEATURES,
  APP_READING,
  APP_WRITING,
  APP_WORD_WORK,
  APP_WORD_SORT,
  APP_WORD_DIVISION,
  APP_ASSESSMENT,
} from '../../constants';
import {faEllipsisV} from '@fortawesome/pro-regular-svg-icons';

export default function Exercise() {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const [isMenuOpen, toggleMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const userGroup = useSelector(selectUserGroup);
  const exercises = useSelector(selectExercises);

  const queryStrings = queryString.parse(location.search);

  const {exerciseID} = useParams();

  const exercise = exercises.find((exercise) => exercise._id === exerciseID);
  const exerciseType = queryStrings.type || exercise?.type;
  const {
    tier: {features},
  } = userGroup;
  const isContentProducerGroup = features.includes(FEATURES.VISIBILITY_PUBLIC);
  const isVisibilityChipVisible = !isContentProducerGroup && exercise?.visibility;

  useEffect(() => {
    dispatch(fetchExercise(exerciseID));
  }, [dispatch, exerciseID]);

  function handleClickExerciseMenu(event) {
    setAnchorEl(event.currentTarget);
    toggleMenu(true);
  }

  return (
    <>
      <ExerciseMenu
        anchorEl={anchorEl}
        isMenuOpen={isMenuOpen}
        toggleMenu={toggleMenu}
        exercise={exercise}
        isEditVisible={false}
        onDeleteComplete={() => history.push(`/builder/exercises?type=${exerciseType}`)}
      />

      <PrimaryAppBar />
      <SecondaryAppBar title={exercise?.name} backURL={`/builder/exercises?type=${exerciseType}`}>
        {isVisibilityChipVisible && <VisibilityChip visibility={exercise.visibility} isDarkBackground />}
        <IconButton
          onClick={handleClickExerciseMenu}
          size="large"
          className="bg-brandorange m-l-15"
          sx={{width: 45, height: 45, '&:hover': {backgroundColor: 'rgba(238, 65, 39, 0.8)'}}}
        >
          <FontAwesomeIcon icon={faEllipsisV} size="xs" className="clr-gray-200" />
        </IconButton>
      </SecondaryAppBar>

      {exerciseType === APP_READING && <CreateEditReadingExercise exercise={exercise} />}
      {exerciseType === APP_WRITING && <CreateEditWritingExercise exercise={exercise} />}
      {exerciseType === APP_WORD_WORK && <CreateEditWordWorkExercise exercise={exercise} />}
      {exerciseType === APP_WORD_SORT && <CreateEditWordSortExercise exercise={exercise} />}
      {exerciseType === APP_WORD_DIVISION && <CreateEditWordDivisionExercise exercise={exercise} />}
      {exerciseType === APP_ASSESSMENT && <CreateEditAssessmentExercise exercise={exercise} />}
    </>
  );
}
